import React from 'react';
import TranslationNamespaces from '../../locales/TranslationNamespaces';
import { useTranslation } from 'react-i18next';
import { Typography, useTheme } from '@mui/material';
import { useCache } from '../../state/CachingContext';
import ApiHelper from '../../helpers/ApiHelper';
import { useNavigate } from 'react-router-dom';
import { QSpinner } from '@kubiq-base/core';

// IDP-handler errors
// 0: OK (Encrypted data returned).
// -1: Error occurred in external provider.
// -2: No claims data returned by external provider.
// -3: No encrypted data returned by AtiQx.ID API (probably user not found and not transparent logging in).
// -4: Error occurred in AtiQx.ID API.
// -5: Error occurred in AtiQx.ID.IdpHandler.
// -6: Invalid OrganisationsApplicationsGuid, couldn't load returnUrl.

const IdpHandler = (): JSX.Element => {
  const { t } = useTranslation(TranslationNamespaces.idpHandler);
  const theme = useTheme();
  const navigate = useNavigate();
  const { getCache } = useCache();
  const session = getCache();
  const [isLoading, setIsLoading] = React.useState(true);
  const [code] = React.useState(session.error);

  React.useEffect(() => {
    if (code) {
      if (code === '0' && session.returnurl && session.data && session.iv) {
        ApiHelper.redirectToExternal(
          session.returnurl,
          { data: session.data, iv: session.iv },
          session.source === 'app' ? session.source : undefined,
        );
      } else {
        setIsLoading(false);
      }
    } else {
      // TODO: No redirect just message?
      navigate('/');
    }
  }, [code]);

  return (
    <>
      {isLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 72 }}>
          <QSpinner />
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: 8,
            textAlign: 'center',
          }}
        >
          <Typography variant='h4' style={{ fontWeight: 600, marginBottom: theme.spacing(2) }}>
            {t('wentWrong')}
          </Typography>
          {code && (
            <Typography variant='h6' style={{ marginBottom: theme.spacing(2) }}>
              {t('loginFailed')} <b style={{ color: theme.palette.error.main }}>{code}</b>
            </Typography>
          )}
          <Typography variant='subtitle1'>
            {t('tryAgain')}
            {code && t('withCode')}...
          </Typography>
        </div>
      )}
    </>
  );
};

export default IdpHandler;
